import { Category } from '@modules/common/types';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';
import { FeedbackLabelList } from '../FeedbackLabelList';
import { FeedbackLabelListProps } from '../FeedbackLabelList/FeedbackLabelList';
import { FeedbackCategoryDetailedView } from './FeedbackCategoryDetailedView';
import { FeedbackCategoryListView } from './FeedbackCategoryListView';

export interface FeedbackCategoryProps {
  feedback: Feedback;
  category: Category;
  isEditPredictionsMode: boolean;
  isDetailedView?: boolean;
  selectedLabels: FeedbackLabel[];
  disabledLabelIDs?: string[];
  disableLabelSelection?: boolean;
  setSelectedLabels?: (selectedLabels: FeedbackLabel[]) => void;
  feedbackLabels?: FeedbackLabel[];
  shouldSortBySelection?: boolean;
  onFeedbackCardLabelClick?: (selectedLabels: FeedbackLabel[]) => void;
}

export const FeedbackCategory = ({
  feedback,
  category,
  selectedLabels,
  disabledLabelIDs,
  isEditPredictionsMode,
  setSelectedLabels,
  feedbackLabels,
  shouldSortBySelection,
  disableLabelSelection,
  isDetailedView,
  onFeedbackCardLabelClick,
}: FeedbackCategoryProps) => {
  if (!feedbackLabels) {
    return null;
  }

  const renderFeedbackLabelList = (props?: Partial<FeedbackLabelListProps>) => {
    const commonProps: FeedbackLabelListProps = {
      feedback,
      category,
      shouldSortBySelection,
      disabledLabelIDs,
      selectedLabels,
      setSelectedLabels,
      disableLabelSelection,
      labels: feedbackLabels,
      isEditPredictionsMode: false,
    };

    return <FeedbackLabelList {...commonProps} {...props} />;
  };

  if (isDetailedView) {
    return (
      <FeedbackCategoryDetailedView
        category={category}
        isEditPredictionsMode={isEditPredictionsMode}
        renderFeedbackLabelList={renderFeedbackLabelList}
      />
    );
  }

  return (
    <FeedbackCategoryListView
      feedbackLabels={feedbackLabels}
      selectedLabels={selectedLabels}
      shouldSortBySelection={shouldSortBySelection}
      category={category}
      onFeedbackCardLabelClick={onFeedbackCardLabelClick}
      renderFeedbackLabelList={renderFeedbackLabelList}
    />
  );
};
